// THIS IS SAMPLE CODE ONLY - NOT MEANT FOR PRODUCTION USE
import { BlobServiceClient } from "@azure/storage-blob";
import { UserDataService } from "./user.Service";

//Photo Storage
let sasToken, containerName, storageAccountName;

//Video Storage
let Video_sasToken, Video_containerName, Video_storageAccountName;

//Game Score Storage configs
let gameScoreSasToken, gameScoreContainerName, gameScoreStorageAccountName;

function getIndividualEnumerationData(enumData, childID) {
  return enumData.find((r) => r.childID == childID).childName;
}

async function getStorageAccessConfigData() {
  let storageAccessConfig =
    await UserDataService.getStorageAccessEnumerationConfigData();
  return storageAccessConfig.data;
}

getStorageAccessConfigData().then((storageAccessConfig) => {
  if (storageAccessConfig && storageAccessConfig.length > 0) {
    sasToken = getIndividualEnumerationData(storageAccessConfig, 1);
    storageAccountName = getIndividualEnumerationData(storageAccessConfig, 2);
    containerName = getIndividualEnumerationData(storageAccessConfig, 3);

    Video_sasToken = getIndividualEnumerationData(storageAccessConfig, 4);
    Video_storageAccountName = getIndividualEnumerationData(
      storageAccessConfig,
      5
    );
    Video_containerName = getIndividualEnumerationData(storageAccessConfig, 6);

    //#Set Game Score configuration.
    gameScoreSasToken = getIndividualEnumerationData(storageAccessConfig, 7);
    gameScoreStorageAccountName = getIndividualEnumerationData(
      storageAccessConfig,
      8
    );
    gameScoreContainerName = getIndividualEnumerationData(
      storageAccessConfig,
      9
    );
  }
});

//Photo baseUrl
export const baseUrl = (name) => {
  return `https://${storageAccountName}.blob.core.windows.net/${containerName}/${name}?${sasToken}`;
};

// Feature flag - disable storage feature to app if not configured
export const isStorageConfigured = () => {
  return !(!storageAccountName || !sasToken);
};

// return list of blobs in container to display
export const getBlobsInContainer = async () => {
  const returnedBlobUrls = [];
  const blobService = new BlobServiceClient(
    `https://${storageAccountName}.blob.core.windows.net/?${sasToken}`
  );
  // get Container - full public read access
  const containerClient = blobService.getContainerClient(containerName);

  // get list of blobs in container
  // eslint-disable-next-line
  for await (const blob of containerClient.listBlobsFlat({
    includeMetadata: true,
  })) {
    // if image is public, just construct URL
    returnedBlobUrls.push({
      //url: `https://${storageAccountName}.blob.core.windows.net/${containerName}/${blob.name}`,
      videoUrl: `https://ik.imagekit.io/mediabucket/chq-sandbox/${blob.name}`,
      drillType: blob.metadata?.drilltype ?? "",
      playerName: blob.metadata?.playername ?? "",
      createdDate: blob.properties.createdOn,
    });
  }

  return returnedBlobUrls;
};

const createBlobInContainer = async (containerClient, file) => {
  // create blobClient for container
  const blobClient = containerClient.getBlockBlobClient(file.name);

  // set mimetype as determined from browser with file upload control
  const options = { blobHTTPHeaders: { blobContentType: file.type } };

  // upload file
  await blobClient.uploadBrowserData(file, options);
  //await blobClient.setMetadata({ UserName: "sachin" });
};

const uploadFileToBlob = async (file) => {
  if (!file) return [];

  // get BlobService = notice `?` is pulled out of sasToken - if created in Azure portal
  const blobService = new BlobServiceClient(
    `https://${storageAccountName}.blob.core.windows.net/?${sasToken}`
  );
  // get Container - full public read access
  const containerClient = blobService.getContainerClient(containerName);

  // upload file
  createBlobInContainer(containerClient, file);
  return true;

  // get list of blobs in container
  //return getBlobsInContainer(containerClient);
};
// </snippet_uploadFileToBlob>

export default uploadFileToBlob;

//Video baseUrl
export const Video_baseUrl = (name) => {
  return `https://${Video_storageAccountName}.blob.core.windows.net/${Video_containerName}/${name}?${Video_sasToken}`;
};

export const uploadVideoToBlob = async (file) => {
  if (!file) return [];

  // get BlobService = notice `?` is pulled out of sasToken - if created in Azure portal
  const blobService = new BlobServiceClient(
    `https://${Video_storageAccountName}.blob.core.windows.net/?${Video_sasToken}`
  );
  // get Container - full public read access
  const containerClient = blobService.getContainerClient(Video_containerName);

  // upload file
  createBlobInContainer(containerClient, file);
  return true;
};

export const uploadVideoToBlobWithProgress = async (
  file,
  fnSetProgress,
  metadata = {}
) => {
  if (!file) return [];

  // get BlobService = notice `?` is pulled out of sasToken - if created in Azure portal
  const blobService = new BlobServiceClient(
    `https://${Video_storageAccountName}.blob.core.windows.net/?${Video_sasToken}`
  );
  // get Container - full public read access
  const containerClient = blobService.getContainerClient(Video_containerName);

  var customBlockSize =
    file.size > 1024 * 1024 * 10 ? 1024 * 1024 * 4 : 1024 * 512;
  blobService.singleBlobPutThresholdInBytes = customBlockSize;

  const client = containerClient.getBlockBlobClient(file.name);
  try {
    const response = await client.uploadBrowserData(file, {
      blockSize: customBlockSize,
      oncurrency: 20, // 20 concurrency
      onProgress: (ev) => {
        if (typeof fnSetProgress === "function")
          fnSetProgress((ev.loadedBytes / file.size) * 100);
      },
      blobHTTPHeaders: { blobContentType: file.type },
      metadata: metadata,
    });

    //console.log("response", response);
    if (response.errorCode != null) {
      console.log("failed");
      return false;
    }
    return true;
  } catch (e) {
    console.error("File saving to Azure failed - " + e);
    throw e;
  }
};

//Game Score Storage baseUrl
export const gameScoreBaseUrl = (name) => {
  return `https://${gameScoreStorageAccountName}.blob.core.windows.net/${gameScoreContainerName}/${name}?${gameScoreSasToken}`;
};

export const uploadGameScoreFileToBlob = async (file) => {
  if (!file) return [];

  // get BlobService = notice `?` is pulled out of sasToken - if created in Azure portal
  const blobService = new BlobServiceClient(
    `https://${gameScoreStorageAccountName}.blob.core.windows.net/?${gameScoreSasToken}`
  );

  // get Container - full public read access
  const containerClient = blobService.getContainerClient(
    gameScoreContainerName
  );

  // upload file
  createBlobInContainer(containerClient, file);
  return true;
};

export const uploadAnthrosFileToBlob = async (file, metadata) => {
  if (!file) return [];
  // get BlobService = notice `?` is pulled out of sasToken - if created in Azure portal
  const blobService = new BlobServiceClient(
    `https://${Video_storageAccountName}.blob.core.windows.net/?${Video_sasToken}`
  );
  // get Container - full public read access
  const containerClient = blobService.getContainerClient(Video_containerName);

  // upload file
  await createBlobInContainer(containerClient, file, metadata);
};
